import React, {useEffect, useState, createRef} from 'react'
import styles from './index.module.less'
import Header from "../../../components/header";
import Bottom from "../../../components/contact";
import Reserve from "../../../components/reserve";
import BasicLayout from "../../../layout/basicLayout";
import PageTop from "../../../components/pageTop";
import Module from "../../../components/module";
import {Swiper, SwiperSlide} from 'swiper/react';
import {useHistory} from 'react-router'

const Cooperate = (props) => {
    const history = useHistory()
    const [current, setCurrent] = useState(0);
    const [swiperObj, setSwiperObj] = useState(null);

    let swiperRef = createRef();
    const slideChange = (e) => {
        setCurrent(e.activeIndex);
    };

    const cooperateList = [
        {
            icon: '/img/gaoxiao.png',
            title: '高校',
            desc: '基础建设、信息化建设、运营服务 、教学服务、教育实训、就业指导',
            bg: '/img/gaoxiao1.png'
        }, {
            icon: '/img/xiangmuyunyingshang.png',
            title: '项目运营商',
            desc: '项目共营、项目共建、平台服务、 技术支持',
            bg: '/img/yunying.png'
        }, {
            icon: '/img/tongxinyunyingshang.png',
            title: '通信运营商',
            desc: '项目共建、融合套餐',
            bg: '/img/tongxun.png'
        }, {
            icon: '/img/pingtaigongsi.png',
            title: '平台公司',
            desc: '数据共享、流量运营',
            bg: '/img/pingtai.png'
        }, {
            icon: '/img/shebeichangshang.png',
            title: '设备厂商',
            desc: '供应链合作、渠道资源共享',
            bg: '/img/changshang.png'
        }, {
            icon: '/img/pay_channel.png',
            title: '支付通道',
            desc: '用户流量',
            bg: '/img/tongdao.png'
        }, {
            icon: '/img/guanggaoshang.png',
            title: '广告商',
            desc: '广告合作',
            bg: '/img/guanggao.png'
        }, {
            icon: '/img/bank.png',
            title: '银行',
            desc: '金融服务、融合套餐、用户流量',
            bg: '/img/yinhang.png'
        }
    ]

    const schoolTabs = [
        {
            id: '1',
            title: '合作案例',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/zhongkeda.png',
                    title: '中国科学技术大学',
                    desc: '同“新”协力，中科大迎新再升级',
                    bg: '/img/anli/zhongkeda.jpg',
                    key: '中国科学技术大学',
                },
                {
                    icon: '/img/anli/schoolBadge/shanyida.png',
                    title: '山东第一医科大学',
                    desc: '神州顶联助力山东第一医科大学高校迎新',
                    bg: '/img/anli/shanyida.jpg',
                    key: '山东第一医科大学',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongjianda.png',
                    title: '山东建筑大学',
                    desc: '与时偕行，神州顶联助山东建筑大学探索实践智慧校园建设',
                    bg: '/img/anli/shandongjianda.jpg',
                    key: '山东建筑大学',
                },
                {
                    icon: '/img/anli/schoolBadge/qilushifanxueyuan.png',
                    title: '齐鲁师范学院',
                    desc: '智慧迎新，科技战疫——齐鲁师范学院应用“AI无接触”技术助力新学年',
                    bg: '/img/anli/qilushifan.jpg',
                    key: '齐鲁师范学院',
                },
                {
                    icon: '/img/anli/schoolBadge/jinanzhiye.png',
                    title: '济南职业学院',
                    desc: '智慧联动，神州顶联携手济南职业学院建设现代化校园',
                    bg: '/img/anli/jinanzhiye.jpg',
                    key: '济南职业学院',
                },
                {
                    icon: '/img/anli/schoolBadge/xijiaocheng.png',
                    title: '西安交通大学城市学院',
                    desc: '神州顶联助力西安交通大学城市学院宿舍升级，共促校园信息化发展',
                    bg: '/img/anli/xijiaocheng.jpg',
                    key: '西安交通大学城市学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongshangzhi.png',
                    title: '山东商业职业学院',
                    desc: '“汗水管理”变“智慧管理”——山东商业职业学院升级宿舍服务',
                    bg: '/img/anli/shandongshangzhi.jpg',
                    key: '山东商业职业学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongchuanmei.png',
                    title: '山东传媒职业学院',
                    desc: '聚焦“底子”功夫，构建校园安全防护墙',
                    bg: '/img/anli/shandongchuanmei.jpg',
                    key: '山东传媒职业学院',
                },
            ],
        },
        {
            id: '2',
            title: '智慧网络',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/shandongjiaotongxueyuan.png',
                    title: '山东交通学院',
                    desc: '山东交通学院两万四师生校园网：济南威海四校区互联升级',
                    bg: '/img/anli/shandongjiaotongxueyuan.png',
                    key: '山东交通学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongchuanmeizhiyexueyuan.png',
                    title: '山东传媒职业学院',
                    desc: '聚焦“底子”功夫，构建校园安全防护墙',
                    bg: '/img/anli/shandongchuanmeizhiyexueyuan.png',
                    key: '山东传媒职业学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongdiyiyikedaxue.png',
                    title: '山东第一医科大学',
                    desc: '为设备赋能：山一大完成 3 万人校园网全场景技术架构',
                    bg: '/img/anli/shandongdiyiyikedaxue.png',
                    key: '山东第一医科大学网络',
                },
                {
                    icon: '/img/anli/schoolBadge/taiyuanshifanxueyuan.png',
                    title: '太原师范学院',
                    desc: '统一认证 + 双栈架构：太原师范学院校园网实现分区域安全管控',
                    bg: '/img/anli/taiyuanshifanxueyuan.png',
                    key: '太原师范学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongjianzhudaxue.png',
                    title: '山东建筑大学',
                    desc: '携手山建大 打造覆盖全校的优质一体化校园网',
                    bg: '/img/anli/shandongjianzhudaxue.png',
                    key: '山东建筑大学网络',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongguanlixueyuan.png',
                    title: '山东管理学院',
                    desc: '校园网覆盖超 80%，大数据预警平台开启智能管理新篇',
                    bg: '/img/anli/shandongguanlixueyuan.png',
                    key: '山东管理学院',
                },
                {
                    icon: '/img/anli/schoolBadge/qilugongyedaxue.png',
                    title: '齐鲁工业大学',
                    desc: '两万师生校园网构建多校区互联新生态',
                    bg: '/img/anli/qilugongyedaxue.png',
                    key: '齐鲁工业大学',
                },
                {
                    icon: '/img/anli/schoolBadge/jiningxueyuan.png',
                    title: '济宁学院',
                    desc: '省属本科校园网标杆：济宁学院大数据驱动智慧管理',
                    bg: '/img/anli/jiningxueyuan.png',
                    key: '济宁学院网络',
                },
            ],
        },
        {
            id: '3',
            title: '智慧考勤',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/jiningzhiyejishuxueyuan.png',
                    title: '济宁职业技术学院',
                    desc: '智慧考勤：开启校园安全与便捷的新篇章',
                    bg: '/img/anli/jiningzhiyejishuxueyuan.png',
                    key: '济宁职业技术学院',
                },
                {
                    icon: '/img/anli/schoolBadge/liaochengdaxuedongchangxueyuan.png',
                    title: '聊城大学东昌学院',
                    desc: '智能门锁与蓝牙考勤双驱联动，赋能应用型本科院校管理升级',
                    bg: '/img/anli/liaochengdaxuedongchangxueyuan.png',
                    key: '聊城大学东昌学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongnvzixueyuan.png',
                    title: '山东女子学院',
                    desc: '智慧考勤体系精准落地，护航女性人才培育高地安全发展',
                    bg: '/img/anli/shandongnvzixueyuan.png',
                    key: '山东女子学院',
                },
                // {
                //     icon: '/img/anli/schoolBadge/guagnximinzudaxue.png',
                //     title: '广西民族大学',
                //     desc: '智能考勤与门锁协同发力，助力民族院校管理精细化',
                //     bg: '/img/anli/guagnximinzudaxue.png',
                //     key: '广西民族大学',
                // },
                {
                    icon: '/img/anli/schoolBadge/shandongchengshijianshezhiyexueyuan.png',
                    title: '山东城市建设职业学院',
                    desc: '智慧考勤系统深度融合，赋能建筑类高职校园管理创新',
                    bg: '/img/anli/shandongchengshijianshezhiyexueyuan.png',
                    key: '山东城市建设职业学院',
                },
            ],
        },
        {
            id: '4',
            title: '新一代一卡通',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/guangxiwuzixuexiao.png',
                    title: '广西物资学校',
                    desc: '超级一卡通赋能升学教育智慧管理',
                    bg: '/img/anli/guangxiwuzixuexiao.png',
                    key: '广西物资学校',
                },
                {
                    icon: '/img/anli/schoolBadge/zhibojiaoyu.png',
                    title: '智博教育',
                    desc: '超级一卡通赋能升学教育智慧管理',
                    bg: '/img/anli/zhibojiaoyu.png',
                    key: '智博教育',
                },
                {
                    icon: '/img/anli/schoolBadge/shijiazhuangxinxigongcheng.png',
                    title: '石家庄信息工程职业学院',
                    desc: '超级一卡通系统全域覆盖，引领信息技术类院校智慧管理新范式',
                    bg: '/img/anli/shijiazhuangxinxigongcheng.png',
                    key: '石家庄信息工程职业学院',
                },
            ],
        },
        {
            id: '5',
            title: '智慧生活',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/shandongzhengfaxueyuan.png',
                    title: '山东政法学院',
                    desc: '告别接水难，山政空气能热泵守护万人用水高峰',
                    bg: '/img/anli/shandongzhengfaxueyuan.png',
                    key: '山东政法学院',
                },
                {
                    icon: '/img/anli/schoolBadge/zhongguokexueyuandaxue.png',
                    title: '中国科学院大学',
                    desc: '步时加热 + 多级过滤，国科大构建智能直饮水解决方案',
                    bg: '/img/anli/zhongguokexueyuandaxue.png',
                    key: '中国科学院大学',
                },
                {
                    icon: '/img/anli/schoolBadge/hebeigongchengjishuxueyuan.png',
                    title: '河北工程技术学院',
                    desc: '智慧生活系统全域覆盖，赋能高水平应用型高校建设',
                    bg: '/img/anli/hebeigongchengjishuxueyuan.png',
                    key: '河北工程技术学院',
                },
                {
                    icon: '/img/anli/schoolBadge/yantaigongchengzhiyejishuxueyuan.png',
                    title: '烟台工程职业技术学院',
                    desc: '空气能热泵技术深度赋能，铸就全国技能人才培养高地',
                    bg: '/img/anli/yantaigongchengzhiyejishuxueyuan.png',
                    key: '烟台工程职业技术学院',
                },
                {
                    icon: '/img/anli/schoolBadge/ludongdaxue.png',
                    title: '鲁东大学',
                    desc: '智能服务体系双维突破，助力省域重点综合性大学跨越式发展',
                    bg: '/img/anli/ludongdaxue.png',
                    key: '鲁东大学',
                },
                {
                    icon: '/img/anli/schoolBadge/jiningxueyuan.png',
                    title: '济宁学院',
                    desc: '双系统智慧升级，驱动应用型本科教育创新发展标杆',
                    bg: '/img/anli/jiningxueyuan.png',
                    key: '济宁学院',
                },
                {
                    icon: '/img/anli/schoolBadge/sichuanwenxuanzhiyexueyuan.png',
                    title: '四川文轩职业学院',
                    desc: '三维服务智慧迭代，筑梦西部职业教育创新高地',
                    bg: '/img/anli/sichuanwenxuanzhiyexueyuan.png',
                    key: '四川文轩职业学院',
                },
                {
                    icon: '/img/anli/schoolBadge/jinangongchengzhiyejishuxueyuan.png',
                    title: '济南工程职业技术学院',
                    desc: '三位一体智慧生态构建，领跑齐鲁高职院校内涵发展',
                    bg: '/img/anli/jinangongchengzhiyejishuxueyuan.png',
                    key: '济南工程职业技术学院',
                }
            ],
        },
        {
            id: '6',
            title: '智慧通行',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/shandongzhiyexueyuan.png',
                    title: '山东职业学院',
                    desc: '从人工布控到智能预警：山职院安防管理效率跃升',
                    bg: '/img/anli/shandongzhiyexueyuan.png',
                    key: '山东职业学院',
                },
                {
                    icon: '/img/anli/schoolBadge/jinanzhiye.png',
                    title: '济南职业学院',
                    desc: '智能门锁 + 超卡开锁，济南职业学院宿舍管理智慧升级',
                    bg: '/img/anli/jinanzhiye.png',
                    key: '济南职业学院通行',
                },
                {
                    icon: '/img/anli/schoolBadge/xianjiaotongdaxue.png',
                    title: '西安交通大学城市学院',
                    desc: '神州顶联助力西安交通大学城市学宿舍升级，共促校园信息化发展',
                    bg: '/img/anli/xianjiaotongdaxue.png',
                    key: '西安交通大学城市学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongshangyezhiyexueyuan.png',
                    title: '山东商业职业学院',
                    desc: '“汗水管理”变“智慧管理”，山东商业职业学院升级宿舍服务',
                    bg: '/img/anli/shandongshangyezhiyexueyuan.png',
                    key: '山东商业职业学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongjianzhudaxue.png',
                    title: '山东建筑大学',
                    desc: '与时偕行，神州顶联助山东建筑大学探索实践智慧校园建设',
                    bg: '/img/anli/shandongjianzhudaxue.png',
                    key: '山东建筑大学',
                },
                {
                    icon: '/img/anli/schoolBadge/guangxijidianzhiyejishuxueyuan.png',
                    title: '广西机电职业技术学院',
                    desc: '焕新校园通行，助力全国示范性高职迈向智慧管理新高度',
                    bg: '/img/anli/guangxijidianzhiyejishuxueyuan.png',
                    key: '广西机电职业技术学院',
                },
                {
                    icon: '/img/anli/schoolBadge/guangxidianlizhiyejishuxueyuan.png',
                    title: '广西电力职业技术学院',
                    desc: '智能门锁系统全面部署，赋能电力行业人才培养高地安全升级',
                    bg: '/img/anli/guangxidianlizhiyejishuxueyuan.png',
                    key: '广西电力职业技术学院',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongyishuxueyuan.png',
                    title: '山东艺术学院',
                    desc: '重塑艺术校园通行体验，护航全国知名艺术学府人才培育',
                    bg: '/img/anli/shandongyishuxueyuan.png',
                    key: '山东艺术学院',
                }
            ],
        },
        {
            id: '7',
            title: '智慧迎新',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/zhongguokexuejishudaxue.png',
                    title: '中国科学技术大学',
                    desc: '同“新”协力，中科大迎新再升级',
                    bg: '/img/anli/zhongguokexuejishudaxue.png',
                    key: '中国科学技术大学',
                },
                {
                    icon: '/img/anli/schoolBadge/shandongdiyiyikedaxue.png',
                    title: '山东第一医科大学',
                    desc: '神州顶联助力山东第一医科大学高校迎新',
                    bg: '/img/anli/shandongdiyiyikedaxue.png',
                    key: '山东第一医科大学',
                },
                {
                    icon: '/img/anli/schoolBadge/qilushifanxueyuan.png',
                    title: '齐鲁师范学院',
                    desc: '智慧迎新，科技战疫——齐鲁师范学院应用“AI无接触”技术助力新学年',
                    bg: '/img/anli/qilushifanxueyuan.png',
                    key: '齐鲁师范学院',
                },
                {
                    icon: '/img/anli/schoolBadge/guangxijingjizhiyexueyuan.png',
                    title: '广西经济职业学院',
                    desc: '智慧迎新方案破解职教报到难题',
                    bg: '/img/anli/guangxijingjizhiyexueyuan.png',
                    key: '广西经济职业学院',
                }
            ],
        },
        {
            id: '8',
            title: '校友会',
            schoolList: [
                {
                    icon: '/img/anli/schoolBadge/shandongnongyegongchengxueyuan.png',
                    title: '山东农业工程学院',
                    desc: '校友会数字化转型实践：智慧互联，共筑校友生态',
                    bg: '/img/anli/shandongnongyegongchengxueyuan.png',
                    key: '山东农业工程学院',
                }
            ],
        },
    ]

    const whyList = [
        {
            title: '投建运营能力',
            icon: 'icon-di1tiao-dingliannengli',
            desc: '为高校免费投建硬件设备及配套管理软件。打酒一体化服务运营，提高师生体验，与中国科学技术大学、西安交通大学、山东师范大学等国内300余所校园建立合作关系，为300多万学生提供全面运营及专业售后服务。',
        }, {
            title: '商业创新能力',
            icon: 'icon-di2tiao--dignliannengli',
            desc: '深耕探索校园数字化建设，创新服务模式为学校提供更贴合实际需求的产品与解决方案；探索多元化业务模式，创新合作模式为客户提供方案规划、投资建设、运营服务、项目定制等业务,与合作伙伴共建共享共生。',
        }, {
            title: '顶层设计能力',
            icon: 'icon-di3tiao-dinglianhezuo',
            desc: '深耕校园数字化十余年，具备“从顶到底，从软到硬”的能力，顶层设计规划经验丰富，底层建设基础逻辑完备，在数智校园建设规划中将持续深化“五个一”数据治理模式,以数据驱动校园业务重构。',
        }, {
            title: '资源整合能力',
            icon: 'icon-di4tiao-dibngliannengli',
            desc: '布局全国市场，与国内百余家项目运营商、上下游企业、通信运营商、银行等保持长期战略合作，已在全国落地300余个校园服务项目；同时，实现了与华为、阿里、腾讯等合作伙伴的产品联合研发、市场联动拓展。',
        }
    ]

    const partners = [
        {
            img: '/img/wechat.png'
        }, {
            img: '/img/alipay.png'
        }, {
            img: '/img/tonglian.png'
        }, {
            img: '/img/yidong.png'
        }, {
            img: '/img/yunshanfu.png'
        }, {
            img: '/img/liantong.png'
        }, {
            img: '/img/华为2.0.png'
        }, {
            img: '/img/深信服2.0.png'
        }, {
            img: '/img/阿里云2.0.png'
        }
    ]

    const [schoolList, setSchoolList] = useState(schoolTabs[0].schoolList);
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        const {type} = props.match.params
        const newType = type ? type : localStorage.getItem('type');
        if (newType) {
            localStorage.setItem('type', newType);
            let anchorElement = document.getElementById(newType)
            if (anchorElement) {
                anchorElement.scrollIntoView();
                console.log("anchorElement.scrollTop", anchorElement.scrollTop)
                setTimeout(() => {
                    window.scrollTo(0, anchorElement.offsetTop - 90);
                }, 100)
            }
        }
    }, [])

    useEffect(() => {
        const {type} = props.match.params
        if (type) {
            localStorage.setItem('type', type);
            let anchorElement = document.getElementById(type)
            if (anchorElement) {
                anchorElement.scrollIntoView()
                setTimeout(() => {
                    window.scrollTo(0, anchorElement.offsetTop - 90);
                }, 100)
            }
        }
    }, [props.match.params])

    return <BasicLayout>
        <Header fixed/>
        <div className={'content_wrapper'}>
            <PageTop bg={'/img/hezuo_bg01.png'} titleTop={`仰望星空  脚踏实地`}
                     titleBottom={'秉承“合能 共营 数智 共享”的宗旨 携手共营新型数字化校园'}/>
            <div className={styles.why_wrapper} id={'why'}>
                <h1>为什么要成为顶联合作者</h1>
                <div className={styles.why_item_wrapper}>
                    {whyList.map(ele => {
                        return <div className={styles.why_item}>
                            <svg className={styles.icon} aria-hidden="true">
                                <use xlinkHref={`#${ele.icon}`}></use>
                            </svg>
                            <div className={styles.icon_text}>
                                <h4>{ele.title}</h4>
                                <div style={{fontSize: 13, color: '#666'}}>{ele.desc}</div>
                            </div>
                        </div>
                    })}
                </div>
            </div>

            <Module title={'合作模式'} eng={'Cooperative Mode'} id={'moshi'}>
                <div className={styles.cooperate_wrapper}>
                    {cooperateList.map((ele, index) => {
                        return <div className={styles.cooperate_item} key={index}>

                            <div className={styles.cooperate_item_back}>
                                <img src={ele.bg} className={styles.bg}/>
                                <img className={styles.cooperate_img} src={ele.icon}/>
                                <div className={styles.cooperate_title}>{ele.title}</div>
                                <div className={styles.cooperate_desc}>{ele.desc}</div>
                            </div>
                            <div className={styles.cooperate_item_front}>

                                <img className={styles.cooperate_img} src={ele.icon}/>
                                <div className={styles.cooperate_title}>{ele.title}</div>
                                <div className={styles.cooperate_desc}>{ele.desc}</div>
                            </div>
                        </div>
                    })}
                </div>
            </Module>

            <Module id={'partner'} title={'合作伙伴'} eng={'Partner'} style={{backgroundColor: '#f4f8fc'}}>
                <div className={styles.partner_wrapper}>
                    {partners.map((ele, index) => {
                        return <div className={styles.partner_item} key={index}>
                            <img src={ele.img}/>
                        </div>
                    })}
                </div>
            </Module>

            <Module id={'anli'} title={'合作案例'} eng={'Casus'}>
                <div className={styles.hezuohuoban_tabs}>
                    {
                        schoolTabs.map((ele, index) => {
                            return <div
                                key={index}
                                className={styles.tabs_item}
                                onClick={() => {
                                    setSchoolList(ele.schoolList);
                                    setTabIndex(index);
                                }}
                                style={tabIndex === index ? {borderBottom: '5px solid #1d33f9', backgroundColor: '#FFFFFF'} : {}}
                            >{ele.title}</div>
                        })
                    }
                </div>
                <div className={styles.cooperate_wrapper}>
                    {schoolList.map((ele, index) => {
                        return <div className={styles.cooperate_item} key={index}
                                    onClick={() => {
                                        history.push({
                                            pathname: '/school/detail',
                                            query: {title: ele.key}
                                        })
                                    }}>
                            <div className={styles.cooperate_item_back}>
                                <img src={ele.bg} className={styles.bg}/>
                                <div className={styles.cooperate_desc}>{ele.desc}</div>
                            </div>
                            <div className={styles.cooperate_item_front}>
                                <img className={styles.cooperate_img} src={ele.icon}/>
                                <div className={styles.cooperate_title}>{ele.title}</div>
                                <div className={styles.cooperate_desc}>{ele.desc}</div>
                            </div>
                        </div>
                    })}
                </div>
            </Module>

            <Module id={'yuanxiao'} title={'合作院校'} eng={'Partner Institutions'}>
                <div className={styles.swiper_wrapper}>
                    <Swiper
                        ref={swiperRef}
                        grabCursor
                        autoplay
                        navigation
                        loop={true}
                        onSlideChange={slideChange}
                        onSwiper={swiper => (setSwiperObj(swiper))}>
                        {['/img/school_1.jpg', '/img/school_2.jpg', '/img/school_3.jpg', '/img/school_4.jpg',].map((ele, index) => {
                            return <SwiperSlide key={index}>
                                <div className={styles.content_wrapper}>

                                    <img src={ele}/>
                                </div>
                            </SwiperSlide>;
                        })}
                    </Swiper>
                </div>
            </Module>

        </div>
        <Bottom/>
        <Reserve/>
    </BasicLayout>
}
export default Cooperate
